/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProductAdministrationDtoCollectionResponseFromDiscriminatorValue, type ProductAdministrationDtoCollectionResponse } from '../models/index.js';
// @ts-ignore
import { createODataErrorFromDiscriminatorValue, type ODataError } from '../models/oDataErrors/index.js';
// @ts-ignore
import { CountRequestBuilderRequestsMetadata, type CountRequestBuilder } from './count/index.js';
// @ts-ignore
import { type WithProductCodeItemRequestBuilder, WithProductCodeItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Provides operations to manage the collection of ProductAdministrationDto entities.
 */
export interface ProductAdministrationOverviewRequestBuilder extends BaseRequestBuilder<ProductAdministrationOverviewRequestBuilder> {
    /**
     * Provides operations to count the resources in the collection.
     */
    get count(): CountRequestBuilder;
    /**
     * Provides operations to manage the collection of ProductAdministrationDto entities.
     * @param productCode The unique identifier of ProductAdministrationDto
     * @returns {WithProductCodeItemRequestBuilder}
     */
     byProductCode(productCode: number) : WithProductCodeItemRequestBuilder;
    /**
     * Get entities from ProductAdministrationOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ProductAdministrationDtoCollectionResponse>}
     * @throws {ODataError} error when the service returns a 4XX or 5XX status code
     */
     get(requestConfiguration?: RequestConfiguration<ProductAdministrationOverviewRequestBuilderGetQueryParameters> | undefined) : Promise<ProductAdministrationDtoCollectionResponse | undefined>;
    /**
     * Get entities from ProductAdministrationOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ProductAdministrationOverviewRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Get entities from ProductAdministrationOverview
 */
export interface ProductAdministrationOverviewRequestBuilderGetQueryParameters {
    /**
     * Include count of items
     */
    count?: boolean;
    /**
     * Expand related entities
     */
    expand?: string[];
    /**
     * Filter items by property values
     */
    filter?: string;
    /**
     * Order items by property values
     */
    orderby?: string[];
    /**
     * Search items by search phrases
     */
    search?: string;
    /**
     * Select properties to be returned
     */
    select?: string[];
    /**
     * Skip the first n items
     */
    skip?: number;
    /**
     * Show only the first n items
     */
    top?: number;
}
/**
 * Uri template for the request builder.
 */
export const ProductAdministrationOverviewRequestBuilderUriTemplate = "{+baseurl}/ProductAdministrationOverview{?%24count,%24expand,%24filter,%24orderby,%24search,%24select,%24skip,%24top}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ProductAdministrationOverviewRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "count": "%24count",
    "expand": "%24expand",
    "filter": "%24filter",
    "orderby": "%24orderby",
    "search": "%24search",
    "select": "%24select",
    "skip": "%24skip",
    "top": "%24top",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ProductAdministrationOverviewRequestBuilderNavigationMetadata: Record<Exclude<keyof ProductAdministrationOverviewRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byProductCode: {
        requestsMetadata: WithProductCodeItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["productCode"],
    },
    count: {
        requestsMetadata: CountRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ProductAdministrationOverviewRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ProductAdministrationOverviewRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            XXX: createODataErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createProductAdministrationDtoCollectionResponseFromDiscriminatorValue,
        queryParametersMapper: ProductAdministrationOverviewRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
